import React from 'react'
import { useSelector } from 'react-redux'
// eslint-disable-next-line no-restricted-imports
import { Text } from 'react-native'
import { userSelector } from '@src/selectors/app'
import { CoachDescriptorOptions, getCoachDescriptor } from '@src/utils'

export const CoachLabel = (props: CoachDescriptorOptions) => {
  const user = useSelector(userSelector)

  if (!user) {
    return null
  }

  const descriptor = getCoachDescriptor(user, props)

  return <Text>{descriptor.toString()}</Text>
}
